/**
 * @generated SignedSource<<4b4a598bc94f7022ffa903b1946af2ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PoolElementForm_ElementV2Fragment$data = {
  readonly elementType: ElementTypeV2;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment">;
  readonly " $fragmentType": "PoolElementForm_ElementV2Fragment";
};
export type PoolElementForm_ElementV2Fragment$key = {
  readonly " $data"?: PoolElementForm_ElementV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PoolElementForm_ElementV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PoolElementForm_ElementV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "elementType",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment"
        }
      ],
      "type": "MultipleChoiceElementV2",
      "abstractKey": null
    }
  ],
  "type": "ElementV2",
  "abstractKey": "__isElementV2"
};

(node as any).hash = "0c72e034100e8d2cb9f379a835fe8192";

export default node;
